import React from 'react'

const Digital_Marketing = () => {
  return (
    <div>
        {/* collapseSeventyOne */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingSeventyOne">
                <button className="accordion-button d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSeventyOne" aria-expanded="true" aria-controls="collapseSeventyOne">
                    Digital Marketing
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseSeventyOne" className="accordion-collapse collapse show" aria-labelledby="headingSeventyOne" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <ul>
                        <li>Introduction</li>
                        <li>Market Research</li>
                        <li>Free Set Up your own Website using HTML CSS Templates</li>
                        <li>Email Marketing</li>
                        <li>Copywriting</li>
                        <li>Search Engine Optimization (SEO)</li>
                        <li>YouTube Marketing</li>
                        <li>Facebook Marketing</li>
                        <li>Twitter Marketing</li>
                        <li>Quora Marketing</li>
                        <li>Instagram Marketing</li>
                        <li>LinkedIn Marketing</li>
                        <li>Google AdWords / Ads</li>
                        <li>Google Analytics</li>
                        <li>Conclusion</li>
                    </ul>
                </div>
            </div>
        </div>


    </div>
  )
}

export default Digital_Marketing